module.exports = __webpack_public_path__ + "static/media/goingdown02.460563bc.png";